export default "__VITE_ASSET__BoYuby9y__"